import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Form, Col, Row } from "react-bootstrap";

import { Icon } from "@cdk-uip/react-icon";

import { getFormattedDate } from "../../../../../util/helpers";
import useValidation from "../../../../../util/useValidation";
import {
  alphabetWithSpacePattern,
  alphaNumericWithSpacePattern
} from "../../../../../constants/constants";
import "../../../../../styles/styles.css";

export const FamilyDetailsForm = ({
  fatherName,
  genders,
  relation,
  relationShipTypeId,
  relationshipName,
  showDeleteButton = false,
  spouseName,
  handleOnChangeFamilyDetails,
  handleOnDeleteFamilyDetails
}) => {
  const { handleOnBlurValidation, errors } = useValidation();
  const handleOnBlurInput = e => {
    handleOnBlurValidation(e);
  };
  const handleOnChange = e => {
    handleOnChangeFamilyDetails(e, relationShipTypeId, relation);
  };
  if (relationshipName === "Father") {
    relation.fullName = relation.fullName || fatherName;
  } else if (relationshipName === "Spouse") {
    relation.fullName = relation.fullName || spouseName;
  }

  return relation ? (
    <Fragment>
      <Form.Group
        className="family-background-details-form-group"
        as={Row}
        controlId={relation.id}
      >
        <Col sm={3}>
          <Form.Label>{`${relationshipName} Name*`}</Form.Label>
          <Form.Control
            size="sm"
            required
            type="text"
            name="fullName"
            onChange={handleOnChange}
            value={relation.fullName}
            pattern={alphabetWithSpacePattern}
            onBlur={handleOnBlurInput}
            isInvalid={errors.fullName}
          />

          {errors.fullName && (
            <Form.Control.Feedback type="invalid">
              {errors.fullName.type === "required" && "First Name is required"}
              {errors.fullName.type === "pattern" &&
                "Must contain only alphabets and space"}
            </Form.Control.Feedback>
          )}
        </Col>
        {relationshipName === "Child1" || relationshipName === "Child2" ? (
          <Col sm={3}>
            <Form.Label>{`${relationshipName} Gender*`}</Form.Label>
            <Form.Control
              size="sm"
              required
              as="select"
              name="gender"
              value={relation.gender}
              onChange={handleOnChange}
              onBlur={handleOnBlurInput}
              isInvalid={errors.gender}
            >
              <option value="">Choose...</option>
              {genders.map(gender => (
                <option value={gender.id}>{gender.genderType}</option>
              ))}
            </Form.Control>
            {errors.gender && (
              <Form.Control.Feedback type="invalid">
                {errors.gender.type === "required" && "gender is required"}
              </Form.Control.Feedback>
            )}
          </Col>
        ) : (
          <Col sm={3}>
            <Form.Label>{`${relationshipName} Occupation*`}</Form.Label>
            <Form.Control
              size="sm"
              required
              type="text"
              name="occupation"
              onChange={handleOnChange}
              value={relation.occupation}
              pattern={alphaNumericWithSpacePattern}
              onBlur={handleOnBlurInput}
              isInvalid={errors.occupation}
            />

            {errors.occupation && (
              <Form.Control.Feedback type="invalid">
                {errors.occupation.type === "required" &&
                  "occupation is required"}
                {errors.occupation.type === "pattern" &&
                  "Must contain only alphabets and space"}
              </Form.Control.Feedback>
            )}
          </Col>
        )}
        <Col sm={3}>
          <Form.Label>{`${relationshipName} DOB*`}</Form.Label>
          <Form.Control
            size="sm"
            required
            type="date"
            name="dateOfBirth"
            onChange={handleOnChange}
            value={getFormattedDate(
              relation.dateOfBirth || "",
              undefined,
              "YYYY-MM-DD"
            )}
            onBlur={handleOnBlurInput}
            isInvalid={errors.dateOfBirth}
          />
          {errors.dateOfBirth && (
            <Form.Control.Feedback type="invalid">
              {errors.dateOfBirth.type === "required" && "DOB is required"}
            </Form.Control.Feedback>
          )}
        </Col>
        <Col sm={1}>
          <Form.Label> </Form.Label>
          {showDeleteButton && (
            <Icon onClick={() => handleOnDeleteFamilyDetails(relation.id)}>
              delete
            </Icon>
          )}
        </Col>
      </Form.Group>
    </Fragment>
  ) : (
    <Fragment />
  );
};
const mapStateToProps = ({ candidateDetails }) => ({
  genders: candidateDetails.genders || []
});
export default connect(mapStateToProps)(FamilyDetailsForm);
